import { __extends } from "tslib";
import { SdkMessageTypes } from '../constants';
import { BaseMessageHandler } from './base-message-handler';
import { callServiceAndFormulateAppMessageResult, formulateAppMessageResult, onStatusError, } from './messageHandlingUtils';
/**
 * Responsible for pages.tabs module related message requests.
 */
var PageTabsMessageHandler = /** @class */ (function (_super) {
    __extends(PageTabsMessageHandler, _super);
    function PageTabsMessageHandler(appSdkHost, pageTabsService, telemetryService) {
        var _this = _super.call(this, appSdkHost, telemetryService) || this;
        _this.appSdkHost = appSdkHost;
        _this.pageTabsService = pageTabsService;
        _this.telemetryService = telemetryService;
        return _this;
    }
    PageTabsMessageHandler.prototype.initHandlers = function () {
        var _this = this;
        this.registerHandler(SdkMessageTypes.pages.tabs.navigateToTab, function (_, params) { return callServiceAndFormulateAppMessageResult(_this.pageTabsService.navigateToTab, params); }, {
            errorCallback: function (error, scenario) { return onStatusError(SdkMessageTypes.pages.tabs.navigateToTab, error, scenario); },
        });
        this.registerHandler(SdkMessageTypes.pages.tabs.getTabInstances, function (_, params) {
            return callServiceAndFormulateAppMessageResult(_this.pageTabsService.getTabInstances, params);
        }, {
            errorCallback: function (error, scenario) {
                return _this.onGetTabsError(SdkMessageTypes.pages.tabs.getTabInstances, error, scenario);
            },
        });
        this.registerHandler(SdkMessageTypes.pages.tabs.getMruTabInstances, function (_, params) {
            return callServiceAndFormulateAppMessageResult(_this.pageTabsService.getMruTabInstances, params);
        }, {
            errorCallback: function (error, scenario) {
                return _this.onGetTabsError(SdkMessageTypes.pages.tabs.getMruTabInstances, error, scenario);
            },
        });
    };
    PageTabsMessageHandler.prototype.validateDependencies = function () {
        if (!this.pageTabsService) {
            throw 'No pageTabsService provided';
        }
    };
    PageTabsMessageHandler.prototype.onGetTabsError = function (apiName, error, scenario) {
        scenario === null || scenario === void 0 ? void 0 : scenario.fail("".concat(apiName, " failed ").concat(error));
        var data = { teamTabs: [] };
        return formulateAppMessageResult(data);
    };
    return PageTabsMessageHandler;
}(BaseMessageHandler));
export { PageTabsMessageHandler };
//# sourceMappingURL=page-tabs-message-handler.js.map